import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

import { MatCardModule, MatCard } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { AppComponent } from './app.component';
import { ErrorComponent } from './error/error.component';
import { UserVerificationDialog } from './verifyAuth/verify.component'
import { HubStatusDialog } from './dashboard/hubStatusDialog/hubStatus.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { LoginComponent } from './auth/login/login.component';
import { SignUpComponent } from './auth/signUp/signUp.component';
import { AuthInterceptor } from './auth/auth-interceptor'
import { ErrorInterceptor } from './error-interceptor';
import { DashboardComponent } from './dashboard/home/dashboard.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatListModule} from '@angular/material/list';
import {MatIconModule} from '@angular/material/icon';
import {MatDividerModule} from '@angular/material/divider';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { GoogleChartsModule } from 'angular-google-charts';
import {MatStepperModule} from '@angular/material/stepper';
import {NgxPaginationModule} from 'ngx-pagination';




import { NbThemeModule, NbToastrModule, NbInputModule, NbFormFieldModule, NbActionsModule, NbCheckboxModule, NbPopoverModule, NbTabsetModule, NbTooltipModule, NbAlertModule, NbDialogModule } from '@nebular/theme';
import { NbSpinnerModule,NbStepperModule, NbAutocompleteModule, NbSidebarModule, NbAccordionModule, NbDatepickerModule, NbRadioModule, NbContextMenuModule, NbToggleModule, NbTreeGridModule, NbSelectModule, NbSearchModule, NbBadgeModule, NbListModule , NbCardModule, NbUserModule, NbLayoutModule, NbButtonModule, NbMenuModule, NbSidebarService, NbMenuService } from '@nebular/theme';
import { GoogleMapsModule } from '@angular/google-maps'
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NbIconModule } from '@nebular/theme';
import {MatGridListModule} from '@angular/material/grid-list';
import { UserDetailComponent } from './dashboard/user-detail/user-detail.component';
import { SearchUiComponent } from './dashboard/search-ui/search-ui.component';
import { SearchPipe } from './shared/pipes/filterSearch.pipe';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { PlotlyViaWindowModule } from 'angular-plotly.js';
import { EnvServiceProvider } from './env.service.provider';
import { UsersComponent } from './dashboard/users/users.component';
import { MapsComponent } from './dashboard/maps/maps.component';
import { VerifyAccountComponent } from './auth/verify-account/verify-account.component';
import { SocketioService } from './socketio.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import {ClipboardModule} from '@angular/cdk/clipboard';
import { HubTransferComponent } from './dashboard/hub-transfer/hub-transfer.component';
import { HubReplacementComponent } from './dashboard/hub-replacement/hub-replacement.component';
import { NodeSearchPipe } from './shared/pipes/node-search.pipe';
import { HubHistoryComponent } from './dashboard/dialog/hub-history/hub-history.component';
import { NodeHistoryComponent } from './dashboard/dialog/node-history/node-history.component';
import { CustomDaysSummaryComponent } from './dashboard/dialog/custom-days-summary/custom-days-summary.component';
import { CountdownTimerComponent } from './dashboard/dialog/countdown-timer/countdown-timer.component';
import { HubTransferV2Component } from './dashboard/hub-transferv2/hub-transferv2.component';
import { RatingComponent } from './dashboard/rating/rating.component';
import { UtilsComponent } from './dashboard/utils/utils.component';
import { AgGridModule } from 'ag-grid-angular';
import { PacketAnalyzerComponent } from './dashboard/packet-analyzer/packet-analyzer.component';
import { SafePipe } from './shared/pipes/safe_pipe';
import { ActivitylogComponent } from './activitylog/activitylog.component';
import { SafeHtmlPipe } from './safe-html.pipe';
import { PasswordDialogComponent } from './password-dialog/password-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';




@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SignUpComponent,
    ErrorComponent,
    UserVerificationDialog,
    HubStatusDialog,
    DashboardComponent,
    UserDetailComponent,
    SearchUiComponent,
    SearchPipe,
    SafePipe,
    UsersComponent,
    MapsComponent,
    VerifyAccountComponent,
    HubTransferComponent,
    HubReplacementComponent,
    NodeSearchPipe,
    HubHistoryComponent,
    NodeHistoryComponent,
    CustomDaysSummaryComponent,
    CountdownTimerComponent,
    HubTransferV2Component,
    RatingComponent,
    UtilsComponent,
    PacketAnalyzerComponent,
    ActivitylogComponent,
    SafeHtmlPipe,
    PasswordDialogComponent,
    ConfirmDialogComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatCardModule,
    MatButtonModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    HttpClientModule,
    MatDialogModule,
    MatTabsModule,
    MatTableModule,
    NbThemeModule.forRoot({ name: 'default' }),
    NbLayoutModule,
    NbSidebarModule.forRoot(),
    NbButtonModule,
    NbMenuModule.forRoot(),
    NbCardModule,
    NbUserModule,
    NbListModule,
    NbBadgeModule,
    NbSearchModule,
    NbToggleModule,
    NbTreeGridModule,
    NbSelectModule,
    NbRadioModule,
    GoogleMapsModule,
    NbEvaIconsModule,
    NbIconModule,
    MatGridListModule,
    NbContextMenuModule,
    Ng2SearchPipeModule,
    FlexLayoutModule,
    MatListModule,
    MatIconModule,
    NbAccordionModule,
    MatDividerModule,
    MatPaginatorModule,
    PlotlyViaWindowModule,
    NbToastrModule.forRoot(),
    NbInputModule,
    NbFormFieldModule,
    NbActionsModule,
    MatCardModule,
    NbTabsetModule,
    NbCheckboxModule,
    MatProgressBarModule,
    MatSnackBarModule,
    NbDatepickerModule.forRoot(),
    NbPopoverModule,
    GoogleChartsModule.forRoot(),
    ClipboardModule,
    NbAutocompleteModule,
    NbStepperModule,
    MatStepperModule,
    NbSpinnerModule,
    NgxPaginationModule,
    NbTooltipModule,
    NbAlertModule,
    NbDialogModule.forRoot(),
    //ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    AgGridModule.withComponents([])
  ],
  providers: [SocketioService,  SearchPipe,SafePipe, {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}, {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true}, EnvServiceProvider],
  bootstrap: [AppComponent],
  entryComponents: [ErrorComponent, HubHistoryComponent]
})
export class AppModule { }
